import React from 'react';
import { apiManage_rbp } from '../../../request';
import { firstMissingPositive } from '../../../constants/utils';
import _ from 'lodash';
import GlobalNotification from '../../../component/common/snackbar';
import i18n from '../../../i18n';
import { Box, Button, Grid, Typography } from '@mui/material';
import CommonInput from '../../../component/form/common-input.component';
import { MUIDataTableColumnDef } from 'mui-datatables';
import ButtonComponent from '../../../component/button/button.component';
import Table from '../../../component/table/table';
import DialogComponent from '../../../component/dialog/dialog.component';
import Card from '../Card';
import setLoading from '../../../component/linear-determinate';
import DeleteDialogComponent from '../../../component/dialog/delete-dialog.component';


/**
 * 菜品报表主类别标签页
 */
class DishReportLabel extends React.Component<Props, State> {
    public state: Readonly<State> = {
        // 数据
        data: [],
        // 删除确认框
        deleteOpen: false,
        // 当前选中的要删除的项目
        deleteDataIds: [],
        // 加载中 初次加载时候使用
        isLoading: true,
        // 新增数据最好的id
        bestId: 1,
        // 空时是否校验规则
        isEmpty: 0,
        // 数据详情
        detail: undefined,
        // 表格每页行数
        rowsPerPage: 20,
        // 当前选中的菜品报表主类别item
        rowsSelected: []
    }
    // *********************
    // Life Cycle Function
    // *********************
    constructor(props: Props) {
        super(props);
        this.getData = this.getData.bind(this)
    }
    async componentDidMount() {
        await this.init()
        this.setState({
            isLoading: false
        })
    }
    // *********************
    // Default Function
    // *********************
    /**
     * 初始化
     */
    async init() {
        setLoading(true);
        await this.getData();
        setLoading(false);
    }

    /**
     * 获取数据
     * @param detailId number 返回指定的详情数据
     */
    async getData(detailId?: number) {
        const result = await apiManage_rbp.getDishReportLabel()
        // 请求成功
        if (!_.get(result, 'error')) {
            const arr = result.map((item: any) => item.major_group_id || 1)
            // 最合适的id
            const bestId = firstMissingPositive(arr)
            this.setState({
                data: result,
                bestId
            })
            if (typeof detailId !== 'undefined') {
                const detail = result.find((item: any) => item.major_group_id === detailId)
                return detail || {}
            }

        }
    }

    // 删除数据
    async handleDeleteData() {
        try {
            const { deleteDataIds } = this.state;
            // 请求接口
            const result = await apiManage_rbp.delBatchDishReportLabel(deleteDataIds);
            if (!result.error) {
                // 刷新数据
                await this.getData();
                // 清空勾选状态
                this.setState({
                    rowsSelected: []
                })
                GlobalNotification.success(i18n.t('global_text_operate_success'));
            } else {
                GlobalNotification.success(i18n.t('global_text_operate_failure'));
            }
        } catch (error) {
            GlobalNotification.success(i18n.t('global_text_operate_failure'));
        }
    }
    dialogConfig(action: 'CONTENT' | 'TITLE' | 'FUN' = 'TITLE') {
        const { detail, isEmpty } = this.state;
        let content = <div></div>;
        // let fun = async () => { };
        let title = '';
        switch (detail?.dialogType) {
            case 'ADD':
            case 'EDIT':
                if (action === 'CONTENT') {
                    content = (
                        <Grid>
                            <CommonInput
                                variant={'outlined'}
                                label={i18n.t('dish_report_page_tag_name')}
                                regularType={'required'}
                                value={detail.labelName}
                                style={{ width: '100%' }}
                                isEmpty={Boolean(isEmpty)}
                                onChange={(e) => {
                                    const newDetail = detail;
                                    _.set(newDetail, 'labelName', e.target.value);
                                    this.setState({ detail: newDetail });
                                }}
                            />
                        </Grid >
                    )
                } else if (action === 'TITLE') {
                    title = i18n.t('dish_report_page_from_main_type_tag');
                }
                // else {
                //     fun = async () => {
                //         this.handleLabel(detail.dialogType === 'ADD');
                //     };
                // }
                break;
        }
        if (action === 'CONTENT') {
            return content;
        } else if (action === 'TITLE') {
            return title;
        }
        // else if (action === 'FUN') {
        //     return fun;
        // }
    }
    /**
     * 新增、编辑
     */
    async handleLabel(isAdd: boolean) {
        const { detail, bestId } = this.state;
        if (!detail?.labelName.trim()) {
            this.setState({ isEmpty: 1 })
            return
        }
        if (isAdd) {
            const res = await apiManage_rbp.postDishReportLabel({ major_group_id: bestId, major_group_name: detail?.labelName });
            if (!res?.error && res.affectedRows > 0) {
                GlobalNotification.success(i18n.t('google_text_add_succeed'));
            } else {
                GlobalNotification.error(i18n.t('google_text_add_failed'));
            }
        } else {
            const res = await apiManage_rbp.patchDishReportLabel({ major_group_id: detail.id, major_group_name: detail?.labelName });
            if (!res?.error && res.changedRows >= 0) {
                GlobalNotification.success(i18n.t('google_text_edit_succeed'));
            } else {
                GlobalNotification.error(i18n.t('google_text_edit_failed'));
            }
        }
        this.setState({
            detail: undefined
        })
        await this.getData();
    }

    /**
     * 选中项，表格头部工具栏显示
     * @returns
     */
    public handleTableToolbarSelectRender(
        selectedRows: { data: Array<{ index: number; dataIndex: number }>; lookup: { [key: number]: boolean } },
    ): React.ReactNode {
        // 选中的数据
        const dishSelected = selectedRows.data.map((item) => (_.get(this.state.data, `[${item.dataIndex}].major_group_id`, 0)));
        return (
            <Box padding={'4px 12px'}>
                <ButtonComponent
                    action='DELETE'
                    handleClick={() => {
                        this.setState({
                            deleteOpen: true,
                            deleteDataIds: dishSelected
                        })
                    }}
                />
            </Box>
        )
    }

    // *********************
    // View
    // *********************

    render() {
        const { data, deleteOpen, isLoading, detail, rowsPerPage, rowsSelected } = this.state;
        // 列
        const columns: MUIDataTableColumnDef[] = [
            {
                name: 'major_group_id',
                label: 'id',
                options: {
                    sort: true,
                }
            },
            {
                name: 'major_group_name',
                label: i18n.t('global_text_name'),
                options: {
                    sort: true,
                }
            }
        ]
        return (
            <Box hidden={isLoading}>
                <Card
                    title={(
                        <Typography variant='h5'></Typography>
                    )}
                    actionRender={(
                        <ButtonComponent
                            titleText={i18n.t('google_text_newly_increased')}
                            action='ADD'
                            handleClick={() => {
                                this.setState({
                                    detail: {
                                        dialogType: 'ADD',
                                        labelName: ''
                                    },
                                    isEmpty: 0
                                })
                            }}
                        />
                    )}
                    contentRender={(

                        <Table
                            data={data}
                            columns={columns}
                            rowsSelected={rowsSelected}
                            onRowSelectionChange={(currentRowsSelected: any[], allRowsSelected: any[], rowsSelected?: number[]) => {
                                this.setState({
                                    rowsSelected: rowsSelected || []
                                })
                            }}
                            otherOption={{
                                viewColumns: true,
                                search: true,
                                pagination: true,
                                rowsPerPage,
                                onChangeRowsPerPage: (nums: number) => {
                                    this.setState({
                                        rowsPerPage: nums,
                                    })
                                },
                                selectableRowsHeader: true,
                                selectableRowsHideCheckboxes: false,
                                selectToolbarPlacement: 'replace',
                                customToolbarSelect: (
                                    selectedRows,
                                ): React.ReactNode => {
                                    return this.handleTableToolbarSelectRender(selectedRows);
                                },
                                // onRowsDelete: (rowsDeleted, newTableData) => {
                                //     this.setState({
                                //         deleteOpen: true,
                                //         deleteDataIds: rowsDeleted.data.map((item) => (
                                //             _.get(data, `[${item.dataIndex}].major_group_id`, 0)
                                //         ))
                                //     })
                                // },
                                onCellClick: (colData, cellMeta: {
                                    colIndex: number;
                                    rowIndex: number;
                                    dataIndex: number;
                                    event: React.MouseEvent<Element, MouseEvent>;
                                }) => {
                                    const item = _.get(data, `[${cellMeta.dataIndex}]`, {} as MajorDataType);
                                    this.setState({
                                        detail: {
                                            dialogType: 'EDIT',
                                            labelName: item?.major_group_name || '',
                                            id: item?.major_group_id
                                        },
                                        isEmpty: 0
                                    })
                                }
                            }}
                        />
                    )}
                />
                {/* 弹窗 */}
                <DialogComponent
                    open={!!detail}
                    fullWidth={false}
                    onClose={() => { this.setState({ detail: undefined }) }}
                    defaultHeaderProps={{
                        title: this.dialogConfig('TITLE') as string,
                        onClose: () => { this.setState({ detail: undefined }) }
                    }}
                    footer={
                        <div>
                            <Button
                                color='primary'
                                variant='outlined'
                                onClick={() => {
                                    this.setState({ detail: undefined })
                                }}
                            >
                                {i18n.t('google_text_public_button_cancel')}
                            </Button>
                            <Box marginLeft={4} display='inline-block'>
                                <ButtonComponent
                                    variant='contained'
                                    handleClick={async () => {
                                        await this.handleLabel(detail.dialogType === 'ADD');
                                        // const fun = this.dialogConfig();
                                        // if (typeof fun === 'function') {
                                        //     await fun();
                                        // }
                                    }}
                                >
                                    {i18n.t('google_text_confirm')}
                                </ButtonComponent>
                            </Box>
                        </div>
                    }
                >
                    <Grid style={{ padding: '8px 8px' }}>
                        {this.dialogConfig('CONTENT')}
                    </Grid >
                </DialogComponent >
                {
                    deleteOpen &&
                    <DeleteDialogComponent
                        {...{
                            title: i18n.t('google_text_public_button_delete'),
                            open: true,
                            onCancel: () => {
                                this.setState({
                                    deleteOpen: false
                                })
                            },
                            onConfirm: async () => {
                                await this.handleDeleteData()
                                this.setState({
                                    deleteOpen: false
                                })
                            },
                        }}
                    />
                }
            </Box>
        )
    }
}

export default DishReportLabel;

// *********************
// Type
// *********************
type MajorDataType = { major_group_id?: number, major_group_name?: string };
type Props = {};
type State = {
    // 数据
    data: MajorDataType[];
    // 删除确认框
    deleteOpen: boolean;
    // 当前选中的要删除的项目
    deleteDataIds: number[];
    // 加载中 初次加载时候使用
    isLoading: boolean;
    // 详情数据
    detail?: any;
    // 新增数据最好的id
    bestId: number;
    isEmpty: number;
    // 表格每页行数
    rowsPerPage: number;
    // 当前选中的菜品报表主类别标签item
    rowsSelected: number[];
}